"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.getAcceptanceOfferContent = void 0;
var common_1 = require("../../common");
var COMMON_OFFER_DETAILS = {
    AGREE: 'By accepting, I agree to:',
    INITIAL_PAYMENT_LABEL: '1st payment',
    AUTHORIZATION: 'I authorize Flex to charge my card according to this payment schedule. I acknowledge that payment amounts are estimates and may vary.',
    FEE_DISCLAIMER: common_1.FEE_DISCLAIMER.DEFAULT,
    FEE_DISCLAIMER_CREDIT: common_1.FEE_DISCLAIMER.CREDIT
};
var ACCEPTANCE_OFFER_DETAILS_CONTROL = __assign(__assign({}, COMMON_OFFER_DETAILS), { HEADER: 'You made it to the last step!', BODY_1: 'Remember, Flex pays your full rent directly to your property manager. Review your payment schedule, which reflects your Flex credit line and any applicable fees.', BODY_BOLD: '', BODY_2: '' });
var ACCEPTANCE_OFFER_DETAILS = __assign(__assign({}, COMMON_OFFER_DETAILS), { HEADER: 'Finalize your payment schedule', BODY_1: 'Your payment schedule will start with your', BODY_BOLD: ' {{date}} ', BODY_2: 'bill. Stay on top of your payments each month to keep using Flex.' });
var AUTOPAY_TOGGLE_ACCEPTANCE_OFFER_DETAILS = __assign(__assign({}, COMMON_OFFER_DETAILS), { HEADER: 'Finalize your payment schedule', BODY_1: 'You’ll be able to start splitting rent with your', BODY_BOLD: ' {{date}} ', BODY_2: 'bill.' });
var OON_ACCEPTANCE_OFFER_DETAILS = __assign(__assign({}, COMMON_OFFER_DETAILS), { HEADER: 'Your schedule is ready!', BODY_1: 'You’ll use a Flex-issued payment method to pay your rent in full to your property. Review your payment schedule, which reflects your Flex credit line and any applicable fees.', BODY_2: '', BODY_BOLD: '' });
var SLC_ACCEPTANCE_OFFER_DETAILS = {
    FEE_DISCLAIMER: common_1.FEE_DISCLAIMER.SLC,
    FEE_DISCLAIMER_CREDIT: common_1.FEE_DISCLAIMER.SLC
};
var EMBED_ACCEPTANCE_OFFER_DETAILS = __assign(__assign({}, COMMON_OFFER_DETAILS), { HEADER: 'Your schedule is ready!', BODY_1: 'Finalize your schedule. You’ll be able to split your rent starting with your {{date}} rent bill.', BODY_2: '', BODY_BOLD: '' });
var getAcceptanceOfferContent = function (_a) {
    var isOutOfNetworkUser = _a.isOutOfNetworkUser, isEnabledForSLC = _a.isEnabledForSLC, isEmbed = _a.isEmbed, isAutopayToggleEnabled = _a.isAutopayToggleEnabled, isContentOverhaulEnabled = _a.isContentOverhaulEnabled;
    var content = isContentOverhaulEnabled ? ACCEPTANCE_OFFER_DETAILS : ACCEPTANCE_OFFER_DETAILS_CONTROL;
    if (isOutOfNetworkUser) {
        content = OON_ACCEPTANCE_OFFER_DETAILS;
    }
    if (isEnabledForSLC) {
        content = __assign(__assign({}, content), SLC_ACCEPTANCE_OFFER_DETAILS);
    }
    if (isEmbed) {
        content = EMBED_ACCEPTANCE_OFFER_DETAILS;
    }
    if (isAutopayToggleEnabled) {
        content = AUTOPAY_TOGGLE_ACCEPTANCE_OFFER_DETAILS;
    }
    return content;
};
exports.getAcceptanceOfferContent = getAcceptanceOfferContent;
